import React from "react";

const Footer = () => (
  <footer
    style={{
      padding: "15px",
      textAlign: "center",
      fontSize: "14px",
      background: "rgba(0,0,0,0.4)",
      color: "white",
    }}
  >
    Contact: your@email.com | Telegram: @youruser
  </footer>
);

export default Footer;